export default "__VITE_ASSET__C9Sx6raW__"